/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-20 15:12:36
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-07-01 16:13:46
 */
import common from "../../common/common";
import { routerFor } from "../../common/other";
import configData from "../../config/config";
import recursionRouter from "../../router/add-router";
import router from "../../router/index";
import { getPermission } from "../../api/api-basic";
import { objAny } from "../../common/common-interface";
const state = {
  isLogin: false,
  winOnresize: false, // 窗口变化
  isGetRouter: false, // 是否初始化路由
  keepAliveList: [], //缓存的路由
  goRouter: [], // 经过的路由 tag用到
  toData: {}, // 当前的路由
  routerList: [],
  userInfo: {}, // 用户信息
  menuIndex: 0, // 当前头部的大菜单
  menuList: [], // 菜单列表
  pageLoading: false // 页面加载
};

const getters = {};

const mutations = {
  /**
   * 是否登录
   * @param state
   * @param status 状态
   */
  SET_ISLOGIN(state: objAny, status: boolean): void {
    state.isLogin = status;
  },

  /**
   * 窗口变化是改变
   * @param state
   */
  SET_WINONRESIZE(state: objAny) {
    state.winOnresize = !state.winOnresize;
  },

  /**
   * 动态添加路由
   * @param {*} state
   * @param {object[]} list 后台返回的菜单
   */
  SET_ROUTERLIST(state: objAny, list: object[]) {
    const routerList: any = recursionRouter(list) // eslint-disable-line
    //动态添加路由
    router.addRoutes(routerList);
    state.routerList = routerList;
    state.isGetRouter = true;
  },

  /**
   * 路由变化时执行,保存经过的路由,最多5个,用在tag标签和缓存路由
   * @param {*} state
   * @param {objAny} data 经过路由的数据
   */
  SET_GOROUTER(state: objAny, data: objAny) {
    let isAdd = true;
    const list = state.goRouter;
    list.map((item: objAny) => {
      if (item.url == data.url) {
        isAdd = false;
      }
    });
    if (isAdd) {
      list.push(data);
      if (list.length > 5) {
        list.splice(0, 1);
      }
      state.goRouter = list;
    }
    const keepAliveList: object[] = [];
    list.map((item: objAny) => {
      if (item.componentsName) {
        keepAliveList.push(item.componentsName);
      }
    });
    state.keepAliveList = keepAliveList;
  },

  /**
   *  删除路由 tag
   * @param {*} state
   * @param {number} index
   */
  UP_GOROUTER(state: objAny, index: number) {
    const list = state.goRouter;
    list.splice(index, 1);
    state.goRouter = list;
    const keepAliveList: object[] = [];
    list.map((item: objAny) => {
      keepAliveList.push(item.componentsName);
    });
    state.keepAliveList = keepAliveList;
  },
  /**
   * 当前的路由
   * @param {*} state
   * @param {objAny} data
   */
  SET_TODATE(state: objAny, data: objAny) {
    state.toData = data;
  },
  /*
   * 是否经过路由初始化
   * @param {*} state
   * @param {boolean} status
   */
  SET_ISGETROUTER(state: objAny, status: boolean) {
    state.isGetRouter = status;
  },
  /**
   * 登录信息
   * @param {*} state
   * @param {objAny} data
   */
  SET_USERINFO(state: objAny, data: objAny) {
    state.userInfo = data;
  },
  /**
   * 登录信息
   * @param {*} state
   * @param {objAny} data
   */
  SET_MENULIST(state: objAny, list: object[]) {
    state.menuList = routerFor(list);
  },
  SET_PAGELOADING(state: objAny, status: boolean) {
    state.pageLoading = status;
  }
};
const forMenuChild = function(list: object[]): string {
  let str = "";
  list.map((item: objAny, index: number) => {
    if (index == 0) {
      if (item.children && item.children.length > 0) {
        str = forMenuChild(item.children);
      } else {
        str = item.url;
      }
    }
  });
  return str;
};
const actions = {
  /**
   * 路由初始化
   * @param {*} { commit, state }
   * @param {objAny} obj
   */
  async getRouter({ commit }: objAny, obj: objAny) {
    const loginData: objAny = common.get("sys_loginData");
    const win: objAny = window;
    if (loginData) {
      commit("SET_ISLOGIN", true);
      commit("SET_USERINFO", loginData);
      let toUrl = obj.to.fullPath;
      const ret = await getPermission({ roleId: loginData.rolePkId });

      if (ret.status === configData.apiStatus) {
        const data: objAny[] = [];
        ret.data.map((item: objAny) => {
          if (item.modulePkId == configData.sysModulePkId) {
            data.push(item);
          }
        });
        // 登录进来，首页还没有做的时候
        if (toUrl == "/") {
          toUrl = forMenuChild(data);
        }

        commit("SET_MENULIST", data);
        commit("SET_ROUTERLIST", data);
      }
      obj.next &&
        obj.next({
          path: toUrl
        });
    } else {
      commit("SET_ISGETROUTER", false);
      commit("SET_ISLOGIN", false);

      if (configData.loginUrl && configData.loginUrl != "") {
        win.location.href = configData.loginUrl;
      } else {
        obj.next({
          path: "/login"
        });
      }
    }
    win.onresize = common.debounce(() => {
      commit("SET_WINONRESIZE", true);
    }, 200);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
